// extracted by mini-css-extract-plugin
var _1 = "Toast-module__animatedBackground--UVkSI";
var _2 = "Toast-module__buttons--bfWpa";
var _3 = "Toast-module__dismissButton--EHZK5";
var _4 = "12px";
var _5 = "Toast-module__error--msqWM";
var _6 = "Toast-module__icon--Nf4k0";
var _7 = "Toast-module__main--HhUee";
var _8 = "Toast-module__success--O9YhP";
var _9 = "Toast-module__title--dRpLD";
var _a = "Toast-module__toast--CfV0G";
var _b = "Toast-module__warning--RfPwC";
export { _1 as "animatedBackground", _2 as "buttons", _3 as "dismissButton", _4 as "dismissButtonIconSize", _5 as "error", _6 as "icon", _7 as "main", _8 as "success", _9 as "title", _a as "toast", _b as "warning" }
